import { createFileRoute, notFound } from '@tanstack/react-router';

import { SupplierRecordPage } from '@/features/suppliers/SupplierRecordPage';

export const Route = createFileRoute('/_app/suppliers/$supplierId')({
    component: SupplierRoute,
});

function SupplierRoute() {
    const { supplierId } = Route.useParams();
    const id = Number(supplierId);
    // A junk id in the URL is a dead link, not a record: the not-found page says so rather than
    // the record page asking the API about NaN.
    if (!Number.isInteger(id) || id <= 0) {
        throw notFound();
    }
    return <SupplierRecordPage supplierId={id} />;
}
